export function formatHora(horaStr) {
  if (!horaStr) return '';
  try {
    return new Date(horaStr).toLocaleTimeString('es-VE', { hour: '2-digit', minute: '2-digit' });
  } catch {
    return '';
  }
}

export function formatFecha(horaStr) {
  if (!horaStr) return '';
  try {
    const d = new Date(horaStr);
    const hoy = new Date();
    if (d.toDateString() === hoy.toDateString()) return 'Hoy';
    const ayer = new Date(hoy);
    ayer.setDate(ayer.getDate() - 1);
    if (d.toDateString() === ayer.toDateString()) return 'Ayer';
    return d.toLocaleDateString('es-VE', { day: 'numeric', month: 'long', year: 'numeric' });
  } catch {
    return '';
  }
}

export function mostrarSeparadorFecha(msg, idx, mensajes) {
  if (idx === 0) return true;
  try {
    return new Date(msg.hora).toDateString() !== new Date(mensajes[idx - 1].hora).toDateString();
  } catch {
    return false;
  }
}

export function placeholderOnboarding(pasoActual, paso) {
  if (paso === 0) return 'Escribe tu nombre...';
  if (paso === 1) return 'Escribe tu cedula...';
  if (paso === 2) return 'Escribe tu telefono...';
  if (paso === 3) return 'Comparte tu ubicacion para continuar';
  return 'Escribe tu mensaje...';
}
